export const FAILED_QR_CODE_REDIRECT_URL = '/checkout/finish?zpp=failed';
export const handleQrCodeFailureRedirect = () => {
  window.location.replace(FAILED_QR_CODE_REDIRECT_URL);
};
